import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const baseQuery = fetchBaseQuery({
  baseUrl: BACKEND_URL,
  prepareHeaders: (headers, { getState, endpoint }) => {
    if (endpoint?.endsWith("/upload/cover")) {
      headers.set("Content-Type", "multipart/form-data");
    }
    if (!endpoint?.endsWith("/login-host") || !endpoint?.endsWith("/become-host") || !endpoint?.endsWith("/login-client") || !endpoint?.endsWith("/sign-up-client")) {
      let tokenHost = getState().hostAuth.token;
      let tokenClient = getState().persistedReducer.authclient.token;

      if (tokenHost || tokenClient) {
        headers.set("Authorization", `${tokenHost || tokenClient}`);
      } else {
        tokenHost = localStorage.getItem('host_token')
        tokenClient = localStorage.getItem('client_token')

        if (tokenClient || tokenHost) {
          headers.set("Authorization", `${tokenHost || tokenClient}`);
        }
      }
    }
    return headers;
  }
});

export const apiSlice = createApi({
  baseQuery: baseQuery,
  tagTypes: [
    "Host",
    "Property",
    "EditingProperty",
    'Client',
    'Booking',
    'ExperiencesList',
    'Chats',
    'Messages',
    'SearchResults',
    'Borgo',
    'holiday_package',
    'EditingHolidayPackage'
  ],
  endpoints: builder => ({})
});

